// src/theme.js
import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  fonts: {
    heading: "'Noto Sans JP', sans-serif",
    body: "'Noto Sans JP', sans-serif",
  },
  colors: {
    brand: {
      50: "#e6f6ff",
      100: "#b3e0ff",
      200: "#80caff",
      300: "#4db5ff",
      400: "#1a9fff",
      500: "#3182ce",
      600: "#0066cc",
      700: "#004d99",
      800: "#003366",
      900: "#001a33",
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: "bold",
      },
      variants: {
        solid: (props) => ({
          bg: props.colorScheme === "brand" ? "brand.500" : undefined,
          _hover: {
            bg: props.colorScheme === "brand" ? "brand.600" : undefined,
          },
        }),
      },
    },
    FormLabel: {
      baseStyle: {
        fontWeight: "medium",
      },
    },
  },
});

export default theme;